import comp from "./AIInputBox";
export default comp;
